export const _CONFIG_ = {
  lastdate: '2023-05-31 23:59:59',
  // 子系统首页地址
  redirect_home: 'http://10.206.111.120/manage/HomePage',
  // 登录重定向地址 = login_uri + encodeURIComponent(redirect_home)
  login_uri: 'https://buac.sit.sf-express.com/login?redirect_uri=',
  // 登出重定向地址 = logout_uri + encodeURIComponent(redirect_home)
  logout_uri: 'https://buac.sit.sf-express.com/api/subsystem/pb/token/logout?act=stay&redirect_uri=',
}
